<div class="wrapper wrapper-content animated fadeInRight">
  <app-scorecard
    [scoringType]="'scorecard'"
    [scorecardMode]="'verify'"
  ></app-scorecard>
</div>
